import request from "@/router/axios";

//mailOrderPage 查询邮寄订单
export const mailOrderPage = (current, size, params, search) => {
  return request({
    url: `/api/blade-loanHaveBeenMailed/loanHaveBeenMailed/mailOrderPage`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};

//mailDataList 邮寄资料
export const mailDataList = ( params, search) => {
  return request({
    url: "/api/blade-loanHaveBeenMailed/loanHaveBeenMailed/mailDataList",
    method: "post",
    data: {
      ...params,
      ...search,
    },
  });
};

//mailDataUpdateCopies 修改资料份数
export const mailDataUpdateCopies = (row) => {
  return request({
    url: "/api/blade-loanHaveBeenMailed/loanHaveBeenMailed/mailDataUpdateCopies",
    method: "post",
    data: row,
  });
};

//mailDataSave 邮寄资料
export const mailDataSave = (row) => {
  return request({
    url: "/api/blade-loanHaveBeenMailed/loanHaveBeenMailed/mailDataSave",
    method: "post",
    data: row,
  });
};

